import { useState, type FormEvent } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PASSWORD_MIN_LENGTH } from '@gc/shared';
import { ApiError } from '../api/client.js';
import { useSession } from '../features/auth/session.js';

type Modo = 'entrar' | 'registro';

export function Acceso({ modo }: { modo: Modo }): React.JSX.Element {
  const { sesion, iniciarSesion, registrar } = useSession();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  if (sesion.estado === 'autenticado') {
    const desde = (location.state as { desde?: string } | null)?.desde;
    return <Navigate to={desde ?? '/'} replace />;
  }

  async function enviar(evento: FormEvent): Promise<void> {
    evento.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      if (modo === 'entrar') await iniciarSesion(email, password);
      else await registrar(email, password);
    } catch (causa) {
      // Mensaje del servidor si es un error del contrato; nunca un stack.
      setError(causa instanceof ApiError ? causa.message : 'No se pudo completar la operación.');
    } finally {
      setEnviando(false);
    }
  }

  const titulo = modo === 'entrar' ? 'Iniciar sesión' : 'Crear cuenta';

  return (
    <section>
      <h1>{titulo}</h1>
      <form onSubmit={(evento) => void enviar(evento)} noValidate>
        <p>
          <label htmlFor="email">Email</label>
          <br />
          <input
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(evento) => setEmail(evento.target.value)}
          />
        </p>
        <p>
          <label htmlFor="password">Contraseña</label>
          <br />
          <input
            id="password"
            name="password"
            type="password"
            autoComplete={modo === 'entrar' ? 'current-password' : 'new-password'}
            required
            minLength={modo === 'registro' ? PASSWORD_MIN_LENGTH : undefined}
            value={password}
            onChange={(evento) => setPassword(evento.target.value)}
          />
          {modo === 'registro' && (
            <>
              <br />
              <small>Mínimo {PASSWORD_MIN_LENGTH} caracteres.</small>
            </>
          )}
        </p>
        {error !== null && (
          <p role="alert" style={{ color: 'var(--error)' }}>
            {error}
          </p>
        )}
        <button type="submit" disabled={enviando}>
          {enviando ? 'Enviando…' : titulo}
        </button>
      </form>
      <p>
        {modo === 'entrar' ? (
          <a href="/registro">Crear una cuenta</a>
        ) : (
          <a href="/entrar">Ya tengo cuenta</a>
        )}
      </p>
    </section>
  );
}
